import { render, staticRenderFns } from "./DynamicTemplate.vue?vue&type=template&id=35975db9&scoped=true"
import script from "./DynamicTemplate.vue?vue&type=script&lang=js"
export * from "./DynamicTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35975db9",
  null
  
)

export default component.exports